import client from '../../providers/fetchClient'

export const createBank = data => client.post('/v3/banks', data)

export const updateBank = (id, data) => client.put(`/v3/banks/${id}`, data)

export const getBankById = id => client.get(`/v3/banks/${id}`)
